import * as React from "react";
import { observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import { ToastContainer } from 'react-toastify';
import "./Announcement.scss";

@observer
export default class Announcement extends React.Component<AppProps> {

    render() {
      
        return (
            <ToastContainer />
          );        
    }
}